import { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../apiEndpoints";

export const useGetReminder = ({leadID}) => {
    const [lastReminder, setLastReminder] = useState(null)
    const [allReminders, setAllReminders] = useState(null)

    const fetchData = async() => {
        try{
            
            // Construct lead_id query parameter
            const queryParams = new URLSearchParams({
                lead_id: leadID
            })

            // Get Last Reminder
            const response = await fetch(
                `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_REMINDER.LAST_REMINDER}?${queryParams}`
            )
            const data = await response.json()
            setLastReminder(data)

            // Get All Reminders
            const responseAll = await fetch(
                `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_REMINDER.ALL_REMINDERS}?${queryParams}`
            )
            const allReminders = await responseAll.json()
            setAllReminders(allReminders)
        } catch (error) {
            console.error(error)
        }
    };
    
    useEffect(() => {
        fetchData()
    }, [leadID])
    
    return {lastReminder, allReminders, refetch: fetchData}
}
